import { checkStatus, parseJSON } from './utils';

const config = window.config;

const generateHeaders = (authorization) => ({
  Accept: 'application/vnd.novus+json; version=1',
  'Content-Type': 'application/json',
  Authorization: authorization
});

export const getVisits = (authorization) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/visits/dashboard`, {
    method: 'GET',
    headers: generateHeaders(authorization)
  })
    .then(checkStatus)
    .then(parseJSON);

export const markAsVisited = (authorization, item) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/visits/dashboard?item=${item}`, {
    method: 'POST',
    headers: generateHeaders(authorization)
  })
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/visits.js